module.exports = __webpack_public_path__ + "media/images/brand/footer-slogan-8297b1159c573eb3733429f8e07ea30d.svg";